export default __webpack_public_path__ + "static/variants-532f6956b38303e7a9c91fec7dd7db4c.png";